const gtmMealVouchers = (snacksListOffer) => {
    const items = snacksListOffer?.map((item) => {
        return {
            item_list_id: 'obcerstveni',
            item_list_name: 'Občerstvení',
            affiliation: 'Cinestar',
            item_id: `${item.voucherid}`,
            item_name: `${item.name}`,
            item_brand: `${localStorage.getItem('site')}`,
            item_category: `${item.using_type}`,
            discount: 0.0,
            price: item.price,
        }
    })

    dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            item_list_id: 'obcerstveni',
            item_list_name: 'Občerstvení',
            items: items,
        },
    })
}

export default gtmMealVouchers
